"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Table: function() {
        return Table;
    },
    Thead: function() {
        return Thead;
    },
    Th: function() {
        return Th;
    },
    Tbody: function() {
        return Tbody;
    },
    Td: function() {
        return Td;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Table = function(param) {
    var children = param.children, wrapperClassName = param.wrapperClassName, tableClassName = param.tableClassName;
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _classnames.default)("overflow-hidden border border-gray-200 rounded-t-lg", _defineProperty({}, wrapperClassName, wrapperClassName))
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "overflow-y-hidden overflow-x-auto"
    }, /*#__PURE__*/ _react.default.createElement("table", {
        className: (0, _classnames.default)("min-w-full divide-y divide-gray-200", _defineProperty({}, tableClassName, tableClassName))
    }, children)));
};
var Thead = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _react.default.createElement("thead", {
        className: (0, _classnames.default)("bg-gray-50", _defineProperty({}, className || "", className))
    }, children);
};
var Th = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ _react.default.createElement("th", {
        onClick: onClick,
        scope: "col",
        className: (0, _classnames.default)("px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider", _defineProperty({}, className || "", className))
    }, children);
};
var Tbody = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _react.default.createElement("tbody", {
        className: (0, _classnames.default)("bg-white divide-y divide-gray-200", _defineProperty({}, className || "", className))
    }, children);
};
var Td = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ _react.default.createElement("td", {
        className: (0, _classnames.default)("px-6 py-4 whitespace-nowrap text-sm text-gray-500", _defineProperty({}, className || "", className)),
        onClick: onClick
    }, children);
};

//# sourceMappingURL=Table.js.map